import {
    PerProductState,
    State,
    initialState,
    perProductInitialState,
} from "@/mk2/apps/bazaar/containers/ProductDetail/ProductDetail.reducers";
import { AppState } from "@/mk2/reducers";

export const getProductDetailState = (state: AppState): State =>
    state.containers.bazaar.productDetail || initialState;

export const getProductDetailProductState = (state: AppState, slug: string): PerProductState =>
    getProductDetailState(state).slugs[slug] || perProductInitialState;
